module.exports = __webpack_public_path__ + "img/title.dd34b311.png";